import { Injectable } from '@angular/core';

@Injectable()
export class ConstantsHelper {
  getJobTypeOptions(): Array<{ name: string; value: string; isSelected: boolean }> {
    return [
      { name: 'Dizajn', value: 'Dizajn', isSelected: false },
      { name: 'Modelarnica', value: 'Modelarnica', isSelected: false },
    ];
  }

  getUnitOptions(): Array<string> {
    return ['GRO', 'KG', 'KLM', 'KOM', 'KOT', 'KUT', 'M', 'M2', 'PAK', 'PAR', 'RLN', 'SET'];
  }

  getAdditionalServiceOptions(): Array<{ name: string; value: string; isSelected: boolean }> {
    return [
      { name: 'Servis', value: 'Servis', isSelected: false },
      { name: 'Gratis', value: 'Gratis', isSelected: false },
      { name: 'Reklamacija', value: 'Reklamacija', isSelected: false },
      { name: 'Dizajn', value: 'Dizajn', isSelected: false },
    ];
  }

  getRequestTypeOptions(): Array<{ name: string; value: string }> {
    return [
      { name: 'Standardan', value: 'Standardan' },
      { name: 'Nestandardan', value: 'Nestandardan' },
      { name: 'Trgovački', value: 'Trgovački' },
    ];
  }

  getRequestTypeWithSampleOptions(): Array<{ name: string; value: string }> {
    return [
      { name: 'Standardan', value: 'Standardan' },
      { name: 'Nestandardan', value: 'Nestandardan' },
      { name: 'Uzorak', value: 'Uzorak' },
      { name: 'Trgovački', value: 'Trgovački' },
      { name: 'Reklamacija', value: 'Reklamacija' },
    ];
  }

  getDeliveryOptions(): Array<{ name: string; value: string }> {
    return [
      { name: 'Isporuka', value: 'Isporuka' },
      { name: 'Montaža', value: 'Montaža' },
      { name: 'Isporuka i montaža', value: 'Isporuka i montaža' },
      { name: 'Slanje na lokacije', value: 'Slanje na lokacije' },
      { name: 'Preuzimanje', value: 'Preuzimanje' },
    ];
  }

  getZerothSampleOptions(): Array<string> {
    return [
      'Ne',
      'Da. Prvo uraditi jednu probu, pa nakon kontrole i odobrenja nastaviti produkciju',
      'Da. Prvo uraditi jednu tablu štampe i sečenja, pa nakon kontrole nastaviti produkciju',
      'Napomena. Prvo štampati i seći jedan plot, nakon provere kvaliteta nastaviti produkciju',
    ];
  }

  getDeliveryAddressUploadOptions(): Array<{ name: string; value: string }> {
    return [
      { name: 'Unesi', value: 'text' },
      { name: 'Učitaj fajl', value: 'file' },
    ];
  }

  getWorkerCountOptions(): Array<number> {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  }

  getShippingMethodOptions(): Array<string> {
    return ['Preuzima prevoznik', 'Preuzima montaža', 'Preuzima klijent', 'Slanje brzom poštom', 'Izvoz'];
  }

  getProductTypeOptions(): Array<string> {
    return ['Proizvod', 'Poluproizvod'];
  }
}
